import React, { useState, useMemo } from 'react'
import Modal from '../../Modal'
import styles from '../../../pages/Dashboard.module.scss'
import { Business } from '@mui/icons-material'
import { Skeleton } from '@mui/material'
import useFetchGet from '../../../hooks/useFetchGet'
import { useGeneral } from '../../../context/general'

const EarningCompanyDetails = ({ticker, getTickerName, setIsLoading, index, maxNumber}) => {
    const isInsideRange = useMemo(() => index < maxNumber ,[index, maxNumber])
    const companyName = useMemo(( ) => isInsideRange && ticker && getTickerName(ticker), [getTickerName, ticker, isInsideRange])
    const { data, isLoading } = useFetchGet(ticker && `/api/getCompanyImage?ticker=${ticker}`)
    const { handleCreateProjectAndOpen } = useGeneral()
    const companyImage = useMemo(() => data?.image, [data])

    const handleClick = () => {
        handleCreateProjectAndOpen(ticker)
        setIsLoading(true)
    }

    return companyName ?
    (<div className={styles['earning-company-details']}>
        <div className={styles['image']} onClick={handleClick}>
            { isLoading ? <Skeleton variant="rect" width="100%" height="100%" /> 
            : companyImage
            ? <img src={companyImage} alt='ticker-img'/>
            : <Business fontSize='large'/>}
        </div>
        <div>
            <div className={styles['company-name']}>{companyName}</div>
            <div className={styles['ticker']}>{ticker}</div>
        </div>
    </div>) : <></>
}

export default function EarningsDayModal({open, handleClose, date, dayEarnings, getTickerName, setIsLoading}){
    const [maxIndex, setMaxIndex] = useState(40)

    const sortEarnings = ( earnA, earnB ) => {
        if ( earnA.symbol < earnB.symbol ) return -1
        if ( earnA.symbol > earnB.symbol ) return 1
        return 0
    }

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
        bottom && setMaxIndex(maxIndex + 20)
    }

    const handleCloseModal = () => {
        handleClose()
        setMaxIndex(40)
    }

    return (
        <Modal title={`Earnings ${date}`} open={open} handleClose={handleCloseModal}>
            <div className={styles['earnings-table']} onScroll={handleScroll}>
                {dayEarnings?.sort(sortEarnings).map((earn, index) => 
                <EarningCompanyDetails 
                    ticker={earn.symbol} 
                    key={earn.symbol} 
                    getTickerName={getTickerName} 
                    setIsLoading={setIsLoading}
                    index={index}
                    maxNumber={maxIndex}
                />)}
            </div>
        </Modal>
    )
}